
define('flight-components/mixins/withModal',[
  'flight/lib/compose',
  'flight-components/mixins/withData',
  'App',
  'hogan',
  'URIjs/URI',
  'vendor/jquery.anima'
],

function(compose, withHttp, App, Hogan, URI) {

  /**
   * A flight mixin for handling modals in the UI
   * @exports component:uiModal
   */
  var uiModal = function uiModal() {

    compose.mixin(this, [withHttp]);

    /**
     * The default attributes for this component
     * @type {object}
     */
    var defaults = {
      containerSelector: 'body',
      modalContainerSelector: '.modal',
      headerSelector: '.modal__header',
      contentSelector: '.modal__content',
      triggerSelector: '[data-modal]',
      closeButtonSelector: '.modal-close',
      modalLoaderSelector: '.modal-loader',
      modalShowing: false,
      transitionSpeed: 200,
      minTopOffset: 48,

    };
    this.defaultAttrs(defaults);


    this.transitionModal = function(part, direction, callback) {

       var self = this;
       var $container = $(this.attr.containerSelector);
       var $modal = this.attr.$modal;
       var $closeBtn = this.attr.$closeBtn;
       var $modalContent = this.attr.$modalContent;
       var $modalLoader = this.attr.$modalLoader;

      /** Cache viewport dimensions */
      var viewport = this.attr.viewport = this.attr.viewport || this.calculateViewport();

      var modalContentOffsetTop = (function(){

        if (!self.attr.autoCenter) return self.attr.minTopOffset;
        var top = Math.floor(viewport.middle - $modalContent.innerHeight() / 2);
        var minTop = Math.floor(self.attr.minTopOffset + viewport.scrollTop);
        return (top < minTop) ? minTop : top;
      })();


      if (part === 'overlay' || part === 'all') {

        if (direction === 'in') {

          // set body to fixed positioning
          // add negative top margin to offset scroll position
          $container
            .addClass('modal-active')
            .addClass('fixed')
            // .css('margin-top', -viewport.scrollTop + 'px');

          // $modal.anima(styles.overlay.initial);

          // $modalContent.anima(styles.content.initial);

          // $closeBtn.anima(styles.closeBtn.initial);
          // $modalLoader.anima(styles.loader.initial);

          // $modal.anima(styles.overlay.in, self.attr.transitionSpeed, 'easeOutQuad');
          // $modalLoader.anima(styles.loader.in, self.attr.transitionSpeed);

        } else {

          /** Transition out the entire modal */


          // remove fixed positioning from body
          // reset top margin to 0
          $container
            .removeClass('modal-active')
            .removeClass('fixed')
            .css('margin-top', 0)
            .scrollTop(self.attr.bodyScrollTop);

          callback();
        }

      } else if (part === 'content') {

        if (direction === 'in') {

          // $modalContent.css('top', modalContentOffsetTop);
          $modalLoader.remove();
          callback()

        } else {
          // transition out only modal content
        }

      }

    };


    this.calculateViewport = function() {
      var o = {};
      o.width = window.innerWidth;
      o.height = window.innerHeight;
      o.scrollTop = $(window).scrollTop();
      o.middle = (o.height / 2) + o.scrollTop;
      return o
    };


    /**
     * Adds the modal content to the DOM
     */
    this.showModalContent = function(opts, replace) {

      var self = this;

      /** Insert the provided HTML content into modal content element */
      this.attr.$modalContent.html(opts.content);

      if (!replace) {
        this.transitionModal('content', 'in', function(){

          self.attr.$modalContent.addClass('in');

          /** Attach touch/click handler to close button */
          $(self.attr.closeButtonSelector).on('click', function(ev){
            ev.preventDefault();
            self.killModal();
          });

          self.attr.modalShowing = true;
          self.trigger('uiModalActivated', opts);
        });
      }

      // Set to reload page if browser back button is clicked when in modal
      if (window.history && window.history.pushState) {
        // window.history.pushState('forward', null, window.location.href);
        // var url = URI(window.location.href);
        // var cat = url.query(true).cat
        // $(window).on('popstate', function() {
        //   debugger
        //   // SDC related modals
        //   if (url.hasQuery('cpncode')) {
        //     window.location = url.query({cat:cat}).toString();
        //   }
        //   else {
        //     window.location.reload();
        //   }

        //   $(window).off('popstate');
        // });
      }

    };


    this.killModal = function() {

      var self = this;

      this.transitionModal('all', 'out', function(){
        self.attr.$modal.remove();
        self.attr.modalShowing = false;
        self.trigger('uiModalRemoved');

        $(document).off('keyup.modal');

        delete self.attr.viewport;
      });

      // Skip extra history state established in showModalContent
      if (window.history && window.history.pushState) {
        // $(window).off('popstate');
      }

    };


    this.activateModal = function(opts, $sourceElement) {

      var self = this;

      self.attr.bodyScrollTop = window.scrollY;

      /**
       * 1. request empty modal template markup
       * 2. show modal overlay with loader
       * 3. get the modal content
       * 4. insert content in modal and remove loader
       */

      var template = '<div id="{{attr.id}}" class="modal {{attr.class}}">' +
          '<div class="modal__header">' +
            '<div class="modal__nav">' +
              '<button class="modal-close btn btn--clear tall reverse icon-cancel">Close</button>' +
            '</div>' +
          '</div>' +
          '<img class="modal-loader" src="'  + '/public/images/miniballs.gif" alt="loading" />' +
          '<div class="modal__content">{{content}}</div>'
        '</div>';

      template = Hogan.compile(template);

      var $modal = $( template.render(opts) );

      this.attr.autoCenter = typeof opts.autoCenter === 'undefined';

      /** Appends modal container/overlay to DOM */
      $(this.attr.containerSelector).append($modal);

      /** Caches the modal DOM elements */
      this.attr.$modal = $modal;
      this.attr.$closeBtn = $(this.attr.closeButtonSelector);
      this.attr.$modalContent = $(this.attr.contentSelector);
      this.attr.$modalLoader = $(this.attr.modalLoaderSelector);

      /** Transition in modal overlay */
      this.transitionModal('overlay', 'in', function(){});


      this.getModalContent(opts, function(content){
        if (opts.hasOwnProperty('url')) {
          opts.content = content;
        }

        // setTimeout(function() {
          self.showModalContent(opts, false);
        // }, 20000);
      });


      $(document).on('keyup.modal', function(ev){
        if (ev.keyCode == 27) {
          self.killModal();
        }
      });

    };


    this.getModalContent = function(opts, callback) {
      var self = this;

      self.trigger('uiModalGettingContent', opts); 
      if (opts.hasOwnProperty('url')) {
        this.getHttpPage(opts.url, function(response) {
          self.trigger('uiModalGotContent', opts);
          callback.call(self, response.page.content);
        });
      } else {

        if (opts.content[0] === '#') {
          opts.content = $(opts.content).html();
        }

        self.trigger('uiModalGotContent', opts);
        callback.call(self, opts.content);
      }
    };


    this.updateModalContent = function(opts) {

      this.getModalContent(opts, function(content) {
        opts.content = content;
        this.showModalContent(opts, true);
      });

    };

  };

  return uiModal;

});

